import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setMessagingOpenConversation, setOpenAttendeeMessaging } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { getQueryParam } from '../../../../../utils/functions';
import VyModal from '../../../../common/VyModal';
import MessagingCenter from './MessagingCenter';

const MessagingCenterModal = () => {
  const openAttendeeMessaging = useSelector(({ common }) => common.openAttendeeMessaging);
  const openConversation = useSelector(({ common }) => common.openConversation);
  const isMobilePreview = useSelector(({ common }) => common.isMobilePreview);
  const dispatch = useDispatch();

  const [hide, setHide] = useState(false);

  const handleClose = () => {
    dispatch(setOpenAttendeeMessaging(false));
    dispatch(setMessagingOpenConversation(undefined));
  };

  useEffect(() => {
    /**
     * For the mobile app view, we added a messaging center as a whole page.
     * Using this modal would leave lots of unused space and bad UX.
     * Hence hidden.
     */
    if (typeof window !== 'undefined' && getQueryParam('useappview') === 'true') {
      setHide(true);
    }
  }, []);

  if (hide) return null;

  return (
    <VyModal
      open={openAttendeeMessaging || !!openConversation}
      onClose={handleClose}
      maxWidth="70cqw"
      disablePortal={isMobilePreview}
      hasDefaultPadding={false}>
      {(onClose) => <MessagingCenter />}
    </VyModal>
  );
};
export default MessagingCenterModal;
